import React from 'react';
import '../../scss/controls/_signature.scss';

interface SignatureProps {
    firstName: string;
    lastName: string;
}

export const Signature: React.FC<SignatureProps> = ({ firstName, lastName }) => {
    return (
        <div className='signature'>
            <span className='typedText'>Signed by:</span>
            <span className='sign'>
                {firstName} {lastName}
            </span>
            <span className='typedText'>
                {firstName} {lastName}
            </span>
        </div>
    );
};
